import clsx from "clsx";

// `updated` isn't a severity — it's a cross-cut for "show me only cards
// where something has drifted since my last decision." Grouped here
// alongside severity because it's another one-click filter and the
// rep's mental model ("what do I need to look at?") is the same.
const OPTIONS = [
  { value: "all", label: "All" },
  { value: "critical", label: "Critical" },
  { value: "warning", label: "Warning" },
  { value: "updated", label: "Updated" },
];

export default function SeverityFilter({ value, onChange }) {
  return (
    <div className="grid grid-rows-[auto_auto] gap-1">
      <div className="border-b border-white text-lg font-bold uppercase text-white">
        Show
      </div>
      <div className="mt-1 grid grid-cols-2 gap-1">
        {OPTIONS.map((opt) => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={clsx(
                "rounded-md border px-2 py-1 text-xs font-semibold uppercase transition-colors",
                active
                  ? "border-st-orange bg-white text-st-grey"
                  : "border-secondary text-white hover:border-st-orange hover:text-st-orange",
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
